export default "__VITE_ASSET__BCPAlTb___"